import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AppProvider } from './context/app';
import { AthleteProvider } from './context/athelete';
import { ClubProvider } from './context/club';
import { UserProvider } from './context/users';
import { CoachProvider } from './context/coach';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { CaptureConsole } from "@sentry/integrations";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [
                  new Integrations.BrowserTracing() ,
                  new CaptureConsole({levels: ['log' , 'error']})
                ],
  tracesSampleRate: 1.0,
});

ReactDOM.render(
  <React.StrictMode>
    <AppProvider>
      <AthleteProvider>
        <ClubProvider>
        <CoachProvider>
          <UserProvider>
            <App/>
          </UserProvider>
        </CoachProvider>
        </ClubProvider>
      </AthleteProvider>
      </AppProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
